import { useState } from 'react';
import { PricingGraph } from 'components/PricingGraph/PricingGraph';
import company from '../asssets/data/providers.json';
import s from '../RangeContainer/ContainerCol.module.css';
import st from './GraphContainer.module.css';
import logo from '../asssets/img/calculator.png';

export const GraphContainer = () => {
  const [monthResult, setMonthResult] = useState(0);
  const [yearResult, setYearResult] = useState(0);

  return (
    <div className={s.containerCol}>
      <div className={st.pricingGraphHeader}>
        <a href="https://zaglushka.net" target="blank">
          <img className={st.pricingGraphImg} src={logo} alt="Scaleway logo" />
        </a>
      </div>

      <div className={st.pricingGraphResults}>
        <h4 aria-label="Monthly Price">
          <span className={st.blueText}>{monthResult.toFixed(2)} $</span>
          <span className={st.spanText}>per month</span>
        </h4>

        <h4 aria-label="Yearly Price">
          <span className={st.blueText}>{yearResult.toFixed(2)} $</span>
          <span className={st.spanText}>per year</span>
        </h4>
      </div>

      <PricingGraph
        companys={company}
        monthResult={setMonthResult}
        yearResult={setYearResult}
      />
    </div>
  );
};
